import { ActionTypes } from 'actions/types';

type changeContentStateType = {
    changeContent: boolean;
}
export const initialChangeContentState: changeContentStateType = {
    changeContent: true
}

const contentChangeReducer = (state = initialChangeContentState, action: ActionTypes) => {

  switch (action.type) {


//SET_LRS_STATE   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_CHANGE_CONTENT':
  {

    const val = action.payload

    return {
        changeContent: val
    }
  }


// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};


export { contentChangeReducer };
